import { isIOS, isAndroid, isChrome, isFirefox, isIE } from 'react-device-detect';
import Cryptr from 'cryptr';
import toastr from 'toastr';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import 'moment/locale/es';
// import { array } from 'prop-types';

const cryptr = new Cryptr('utpadmision20222Rahu');

export const Tools = {
    convertDate(value) {
        let _val = moment(value, 'YYYY-MM-DD');
        return _val.format('YYYY-MM-DD');
    },
    
    platformDevice: function() {
        let _data = 'web';
        if( isAndroid ) {
            _data = 'mobile';
        }
        else if( isIOS ) {
            _data = 'mobile';
        }
        else if( isChrome ) {
            _data = 'web';
        }
        else if( isFirefox ) {
            _data = 'web';
        }
        else if( isIE ) {
            _data = 'web';
        }
        else{
            _data = 'web';
        }
        return _data;
    },

    validateEmail: function(value) {
        let response = false;
        let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let validate = regex.test(value);
        if( validate ) {
            response = true;
        }

        return response;
    },

    cryptrData: function(data) {
        return cryptr.encrypt(data);
    },

    decryptrData: function(data) {
        return cryptr.decrypt(data);
    },

    showPreloader: function() {
        if(document.getElementById('preloader')) {
            document.getElementById('preloader').style.display = 'flex';
        }
    },

    hidePreloader: function() {
        if(document.getElementById('preloader')) {
            document.getElementById('preloader').style.display = 'none';
        }
    },

    showToaster: function(type, title, message, timeOut = 3000) {
        switch (type) {
            case 'success':
                toastr.success(title, message, {timeOut})
                break;
            case 'warning':
                toastr.warning(title, message, {timeOut})
                break;
            case 'error':
                toastr.error(title, message, {timeOut})
                break;
        }
    }
}